export const QuickOrderHeader = () => (
  <div className="bg-orange-600 text-white px-5 py-4 shadow-md" data-testid="qo-header">
    <div className="text-lg font-black tracking-tight">GLOBAL AC BANJARBARU</div>
    <div className="text-xs uppercase tracking-widest opacity-90 mt-0.5">Quick Order</div>
    <div className="text-[11px] opacity-80 mt-1">Order cepat tanpa chat Admin</div>
  </div>
);
